import { StyleSheet } from 'react-native';

import { mediaQueryValues } from '../../media-query';

const mediaQuery = mediaQueryValues();

export default StyleSheet.create({
  activityView: {
    flex: 1,
  },
  progressBar: {
    flex: 1,
    marginRight: mediaQuery.small,
  },
  progressHeader: {
    alignItems: 'center',
  },
});
